export const EDIT_TYPES = {
  COPY: 'COPY',
  PATCH: 'PATCH',
  NOEDIT: 'NOEDIT',
};
